<div class="formfield">
  <div class="nes-flex nes-flex-col" [formGroup]="formDate">
    <nes-date-input
      [label]="'USER_DATA.INPUT.BIRTH_DATE.LABEL' | translate"
      [name]="'USER_DATA.INPUT.BIRTH_DATE.LABEL' | translate"
      [dayValue]="formDate.get('birthDate')!.value?.split('-')[0]"
      [monthValue]="formDate.get('birthDate')!.value?.split('-')[1]"
      [yearValue]="formDate.get('birthDate')!.value?.split('-')[2]"
      [cypress]="'birth_date'"
      formControlName="birthDate"
      nesFormControl
      controlled
      nes-id="birthDate"
      id="birthDate"
      [tooltip]="'USER_DATA.INPUT.BIRTH_DATE.TOOLTIP' | translate"
      required
      (nesOnChange)="onKeyup($event)"
    ></nes-date-input>
    @if (getCombinedError() !== undefined) {
      <nes-error-message>
        {{ getCombinedError() }}
      </nes-error-message>
    }
  </div>
</div>
